// extracted by mini-css-extract-plugin
module.exports = {"label":"LabelPrimary_label__3N--P"};